let Functions = [
  {
    name: "Reboot",
    calls: [{ func: "System", args: ["reboot"] }],
    deviceFilter: null,
    commandFilter: "System",
  },
  {
    name: "I2C",
    calls: [{ func: "System", args: ["I2C"] }],
    deviceFilter: null,
    commandFilter: "System",
  },
  {
    name: "Ship It",
    calls: [{ func: "System", args: ["ShipIt"] }],
    deviceFilter: null,
    commandFilter: "System",
  },
  // { name: "Ship It", calls: [{ func: "ShipIt", args: [0] }], deviceFilter: null, commandFilter: "ShipIt" },
  // { name: "Get Device Records", calls: [{ func: "Hub", args: ["get", null] }], deviceFilter: null, commandFilter: "Hub" },
  // { name: "Get This Device's Record", calls: [{ func: "Hub", args: ["get", 0] }], deviceFilter: null, commandFilter: "Hub" },
  // { name: "Stop sending device records", calls: [{ func: "Hub", args: ["get", -1] }], deviceFilter: null, commandFilter: "Hub" },

  {
    name: "Fast Mode (1 hour)",
    calls: [{ func: "System", args: ["Startup"] }],
    deviceFilter: null,
    commandFilter: "System",
  },
  // { name: "Fast Mode (1 hour)", calls: [{ func: "Startup", args: [] }], deviceFilter: null, commandFilter: "Startup" },
  
    {
    name: "Get Queue Size",
    calls: [{ func: "Hub", args: ["Publish Info"] }],
    deviceFilter: null,
    commandFilter: "Hub",
  },
  // { name: "Publish Now", calls: [{ func: "Publish Info", args: [] }], deviceFilter: null, commandFilter: "Publish Info" },

  {
    name: "Publish Now",
    calls: [
      { func: "System", args: ["Publish"] },
      { func: "Hub", args: ["Publish ban 0"] }
    ],
    deviceFilter: null,
    commandFilter: "System",
  },
  // { name: "Publish Now", calls: [{ func: "Publish", args: [] }], deviceFilter: null, commandFilter: "Publish" }
  // and calls: [{ func: "Publish ban 0", args: [] }], deviceFilter: null, commandFilter: "Publish" },
  {
    name: "Ranging Mode 2 Hours (caution!)",
    calls: [{ func: "Cfg", args: ['{"d":{"0":{"gRanging":120}}}'] }],
    deviceFilter: null,
    commandFilter: "Cfg",
  },
  {
    name: "Shuttie Checkin",
    calls: [{ func: "Shuttie", args: ["checkin"] }],
    deviceFilter: null,
    commandFilter: "Shuttie",
  },

  // { name: "Low-Side Compound Changes", calls: [{ func: "CleanFFT", args: [0] }, { func: "FastRead", args: [1] }, { func: "Debug", args: [] }], deviceFilter: ["438"], commandFilter: "CleanFFT" },
  // { name: "Extreme Low-Side Compound Changes", calls: [{ func: "CleanFFT", args: [0] }, { func: "FastRead", args: [2] }, { func: "Debug", args: [] }], deviceFilter: ["438"], commandFilter: "CleanFFT" },
  // { name: "Normal Read Speed and FFT", calls: [{ func: "CleanFFT", args: [1] }, { func: "FastRead", args: [0] }, { func: "Debug", args: [0] }], deviceFilter: ["438"], commandFilter: "CleanFFT" },

  // { name: "Low-Side Compound Changes", calls: [{ func: "Cfg", args: ["{\"d\":{\"0\":{\"Wm\":1,\"Wf\":0}}}"] }, { func: "Hub", args: ["Debug", "Water", "0", "next"] }], deviceFilter: ["438"], commandFilter: "Cfg" },
  // { name: "Extreme Low-Side Compound Changes", calls: [{ func: "Cfg", args: ["{\"d\":{\"0\":{\"Wm\":2,\"Wf\":0}}}"] }, { func: "Hub", args: ["Debug", "Water", "0", "next"] }], deviceFilter: ["438"], commandFilter: "Cfg" },
  // { name: "Normal Read Speed and FFT", calls: [{ func: "Cfg", args: ["{\"d\":{\"0\":{\"Wm\":0,\"Wf\":1}}}"] }, { func: "Hub", args: ["Debug", "Water", "0", "next"] }], deviceFilter: ["438"], commandFilter: "Cfg" }
];

export default Functions;
